<template>
  <div @click.prevent="$emit('input', !value)"
       :class="value ? '_checked' : null"
       class="switch">
    <div class="switch__mark"></div>
    <div v-if="label || $slots.default"
         class="switch__text">
      <slot>{{label}}</slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String
      },
      value: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {}
    }
  }
</script>

<style lang="less">

</style>